import { createModuleStateSelector } from '@americanexpress/travel-selectors';

const getRootState = createModuleStateSelector('travel-lounge-finder-root');

export default getRootState;
